import React, { useState } from 'react'
import { Text } from 'rsuite'
import Modal, {
  ModalDefaultButtonFooter,
} from '../../../../../ui_reusable/Modal'
import { StandardCheckbox } from '../../../../../ui_reusable/StandardInputs'
import styled from '@emotion/styled'

const StyledHeading = styled.h4`
  margin-bottom: 16px;
`

const ExampleBlock = styled.pre`
  background-color: #f8f9fa;
  padding: 10px;
  border-radius: 4px;
  margin: 10px 0;
`

const CheckboxContainer = styled.div`
  margin-top: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
`

interface FileEditValidationModalProps {
  open: boolean
  handleClose: () => void
  onProceed?: () => void
  onHideInFutureChanged?: (checked: boolean) => void
  mode?: 'proceed'
}

const FileEditValidationModal: React.FC<FileEditValidationModalProps> = ({
  open,
  handleClose,
  onProceed,
  onHideInFutureChanged,
  mode = 'proceed',
}) => {
  const [hideInFuture, setHideInFuture] = useState<boolean>(false)

  const handleCheckboxChange = (checked: boolean): void => {
    onHideInFutureChanged?.(checked)
  }

  const handleProceed = (): void => {
    setTimeout(() => {
      handleCheckboxChange(hideInFuture)
    }, 1000)

    onProceed?.()
    handleClose()
  }

  return (
    <Modal open={open} onClose={handleClose} size="md" backdrop="static">
      <Modal.Body>
        <StyledHeading>Important: Dataset Overwrite Format</StyledHeading>
        <Text>
          When overwriting an existing dataset, please ensure your file follows
          this specific format:
        </Text>
        <br />
        <Text>
          <b>Single Column Format Required</b>
        </Text>
        <Text>Your file must contain exactly two columns:</Text>
        <Text>
          <b>Column 1:</b> Date
        </Text>
        <Text>(Accepted formats: YYYY-MM-DD, e.g, 2025-01-01)</Text>
        <Text>
          Monthly Format → YYYY-MM-DD (e.g. 2025-01-01 for January 2025)
        </Text>
        <Text>
          Weekly Format → YYYY-MM-DD, where DD should = Monday for the given
          week (e.g. 2025-01-05 for the first week of 2025, 2025-01-13 for the
          second week of 2025, etc.)
        </Text>
        <Text>
          Daily Format → YYYY-MM-DD (e.g. 2025-01-01, 2025-01-02, 2025-01-03,
          etc)
        </Text>
        <Text>
          <b>Column 2: </b>Value (e.g. 100)
        </Text>
        <Text>
          <b>Column 3: </b>Percent (e.g. 25 for 25% (not 0,25 or 25 %))
        </Text>
        <br />
        <Text>Example:</Text>
        <ExampleBlock>
          <p>date | kpi</p>
          <p>2024-01-01 | 500</p>
          <p>2024-01-02 | 750</p>
        </ExampleBlock>
        <Text>
          Multiple columns are not allowed when overwriting an existing dataset.
        </Text>

        {mode === 'proceed' && (
          <CheckboxContainer>
            <StandardCheckbox
              onChange={(event) => setHideInFuture(event.target.checked)}
              checked={false}
            />
            <Text>Don't show this info again</Text>
          </CheckboxContainer>
        )}
      </Modal.Body>{' '}
      <Modal.Footer>
        <ModalDefaultButtonFooter confirmText="Ok" onConfirm={handleProceed} />
      </Modal.Footer>
    </Modal>
  )
}

export default FileEditValidationModal
